import { TripDivider, TripList } from '../redux/trip/trip.types';

export const getEmojiAndColorForCard = (
  cardId: string,
  lists: TripList[],
  dividers?: TripDivider[]
) => {
  for (const list of lists) {
    if (list.cardOrder?.includes(cardId)) {
      let listLabel = `${list.emoji} ${list.name}`;
      if (dividers) {
        const divider = dividers.find((d) => d.listOrder.includes(list.id));
        if (divider) {
          listLabel = `${divider.emoji} ${divider.name} · ${list.emoji} ${list.name}`;
        }
      }
      return { emoji: list.emoji, color: list.color ?? '#f0f0f0', listLabel };
    }
  }
  return { emoji: '🙂', color: '#f0f0f0', listLabel: '' };
};
